import { Stack, Typography, Divider } from "@mui/material";
import React from 'react';

function Presentation() {

    return (
        <Stack>
            <Typography variant="h4" align="center">
                Inscription bénévoles, auteurs et autrices, animateurs et animatrices pro,
                intervenants et intervenantes PAJ 2026 - 25/26 Avril
            </Typography>
            <Typography variant="h5" align="center" color="grey" mt={2} mb={3}>
                MERCI DE LIRE CE PARAGRAPHE D'EXPLICATION,
                C'EST TRÈS IMPORTANT POUR TE PERMETTRE DE T'INSCRIRE CORRECTEMENT !
            </Typography>

            <Typography variant="body1" align="justify" mb={3}>
                Tu vas participer au festival <b>Place aux Jeux</b>, nous te remercions vivement pour cet engagement !
            </Typography>

            <Typography variant="body1" align="justify" mb={3}>
                Que tu sois bénévole pour les tâches communes, animateur·trice pro, auteur·trice ou animateur·trice sur l'espace dédié de ton association,
                il est <span style={{ color: "red" }}><b>IMPERATIF</b></span> de t'inscrire via ce formulaire, car il nous permet de gérer l'intégralité des intervenant·e·s
                sur le festival (comme la gestion des pass, des repas).
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" color="red" mt={2} mb={3}>
                <b>DATE LIMITE DES INSCRIPTIONS : VENDREDI 10 AVRIL 2026</b>
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" mt={2} mb={3}>
                <b><u>POUR TOUT LE MONDE</u></b>
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Lorsque tu auras soumis ton formulaire, tu recevras un mail récapitulatif de ton inscription avec tes choix
                (les mails récapitulatifs sont envoyés toute les heures, ne sois pas impatient !).
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Si tu souhaites modifier tes informations personnelles ou ton planning ultérieurement,
                merci de contacter l'équipe via le mail <a href="mailto:benevolespaj@gmail.com">benevolespaj@gmail.com</a>,
                en précisant ton nom, prénom et ce que tu veux modifier.
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                <b>Enfin, toutes les personnes inscrites via ce formulaire auront droit à un pass d'entrée gratuit
                    pour tout le week-end, ainsi qu’un accès au catering (boissons chaudes et froides).</b>
            </Typography>
            <Typography variant="h5" align="center" color="grey" mt={2} mb={3}>
                CONFORMÉMENT À LA RGPD, NOUS N'UTILISERONS NI NE COMMUNIQUERONS LES INFORMATIONS COLLECTÉES EN DEHORS DE L'ORGANISATION DE PLACE AUX JEUX
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                En cas de problèmes avec ton inscription, merci de nous contacter via le mail <a href="mailto:benevolespaj@gmail.com">benevolespaj@gmail.com</a>
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" mt={2} mb={3}>
                <b><u>POUR LES BÉNÉVOLES</u></b>
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Le formulaire te permet de choisir les postes qui t'intéressent sur les différents créneaux horaires du week-end.
                Pour chaque créneau, tu as seulement les postes disponibles. Si un poste est complet sur un créneau horaire,
                il disparaîtra automatiquement de la liste des choix. Lorsque tous les postes d'un créneau horaire sont pourvus,
                il ne te sera plus possible de t'inscrire sur ce créneau.
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                <span style={{ color: "red" }}><b>Cette année, l'organisation bénévole change !</b></span> Tu verras dans le planning que les créneaux horaires durent 2h,
                mais sont aussi décalés. Par exemple, le samedi, il y a des créneaux de 08h à 10h, de 10h à 12h, mais aussi de 9h à 11h, de 11h à 13h, etc...
                Cette nouvelle organisation devrait nous permettre de mieux gérer les changements d'équipes mais aussi de te permettre de prendre
                des pauses plus facilement. Par exemple, tu peux prendre un poste de 10h à 12h, te reposer une heure, puis reprendre un autre poste de 13h à 15h.
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Voici la liste des postes proposés et une brève description de ceux ci :
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                <li>
                    <b>Taverne : </b>confectionner et/ou servir les repas et boissons aux visiteurs.
                    <span style={{ color: "red" }}><b> ATTENTION !</b></span> C’est un poste exigeant, qui demande de l’énergie et de l’autonomie,
                    surtout pendant les coups de feu de midi et du soir (<a href="https://drive.google.com/file/d/18EuPFLdTAV2-zn2O4pxKwn27a-9zv4W_/view?usp=drive_link">fiche de poste</a>).
                </li>
                <li>
                    <b>Bar secondaire :</b> nouveau poste ! Il y aura cette année un bar à l’extérieur de la halle Clémenceau, avec proposition
                    de goûter et de boissons. Le poste consiste à servir les visiteurs en boissons et en petit snack (voir des tartines de confiture).
                </li>
                <li>
                    <b>Entrée public :</b> vérifier les sacs, vendre les tickets d'entrées, aider à mettre les bracelets aux visiteurs.
                    Vérifier les bracelets à l'entrée de la Halle et du Barnum  (<a href="https://drive.google.com/file/d/1Y0LZ8ntnoYTNzF_PJmV7pmtmDoy9Plaa/view?usp=drive_link">fiche de poste</a>).
                </li>
                <li>
                    <b>Change :</b> gérer le change €/Pajton ou Pajton/€ pour les visiteurs. Gérer le retour des consignes des verres de la Taverne et du bar extérieur.
                </li>
                <li>
                    <b>Gestion de l’extérieur :</b><br/>
                            - Gérer les jeux installés sur la terrasse de la Bobine : installation le samedi
                            matin et le dimanche matin, désinstallation le samedi soir et le dimanche soir,<br/>
                            - Passer de temps en temps sur la terrasse pour remettre en ordre les jeux<br />
                            - Gérer le barnum : installation des tables et chaises en fonction des animations.
                </li>
                <li>
                    <b>Animation jeux de société :</b> animer les tables de jeux de société dans l'espace associatif
                    (<a href="https://drive.google.com/file/d/14jRtRhiGdHE-kUMRI11ix5hKD_kc7T-U/view?usp=drive_link">fiche de poste</a>).
                </li>
                <li>
                    <b>Animation MdJ petite enfance :</b> animer les espaces petite enfance de la Maison des Jeux (il faut être à l'aise avec les enfants !!).
                </li>
                <li>
                    <b>Animation MdJ jeux traditionnels :</b> animer l'espace jeux traditionnels de la Maison des Jeux (il faut connaître les jeux traditionnels).
                </li>
                <li>
                    <b>Catering :</b> aider à la gestion du catering pour les repas de midi et du soir (gérer l’installation, aider à la vaisselle et au rangement).
                </li>
                <li>
                    <b>Dispo à la halle si besoin :</b> c'est un poste "roue de secours". Nous avons beau être organisé, il y a malheureusement
                    toujours des bénévoles qui se désistent au dernier moment. Ce poste "roue de secours" est là pour nous aider à
                    pallier ces impondérables. Si tu t'inscris comme "roue de secours", tu peux être appelé·e à tout moment pour
                    remplacer au pied levé un autre bénévole qui ne s'est pas présenté·e à son poste (généralement "Taverne", "Bar", "Entrée" ou "Catering").
                    <b> Tu dois donc être présent dans la halle Clémenceau ou à la Bobine !</b>
                </li>
            </Typography>
            <Typography variant="h5" align="center" color="grey" mt={2} mb={3}>
                <span style={{ color: "red" }}><b>IMPORTANT :</b></span> N'OUBLIE PAS DE T'INSCRIRE POUR LES REPAS SI TU ES PRÉSENT·E SUR LE FESTIVAL À CE MOMENT LA ! SINON, TU RISQUES DE NE PAS POUVOIR MANGER.
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" mt={2} mb={3}>
                <b><u>POUR LES PERSONNES QUI FONT DE L'ANIMATION UNIQUEMENT POUR LEUR ASSOCIATION (GO, EXCALIBUR, ECHIQUIER GRENOBLOIS PAR EXEMPLE) OU DES ANIMATIONS JEU DE RÔLES</u></b>
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Remplis les informations personnelles et les repas que tu prendras pendant le festival (samedi midi, samedi soir, dimanche midi).
                En ce qui concerne tes créneaux d'animation, il faut te référer aux personnes en charge de l'organisation de tes animations
                (les Arpenteurs d'Agartha pour les jeux de rôles, tes référents au sein de ton association pour les autres).
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Par contre, si tu souhaites nous aider sur d'autres postes de bénévoles dans les créneaux horaires où tu n'animes pas,
                c'est possible ! Pour cela, il faut choisir comme rôle :
                <b> "Bénévole : je participe aux tâches communes comme la gestion des entrées, la Taverne, l'animation des espaces communs jeux de sociétés et MdJ"</b>,
                et t'inscrire sur les postes et créneaux qui t'intéressent (en laissant vide les créneaux où tu animes sur ton espace).
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" mt={2} mb={3}>
                <b><u>POUR LES AUTEURS, AUTRICES, ANIMATEURS ET ANIMATRICES PRO</u></b>
            </Typography>
            <Typography variant="body1" align="justify" mb={3}>
                Remplis les informations personnelles et les repas que tu prendras pendant le festival (samedi midi, samedi soir, dimanche midi).
                Tu vas animer tes propres tables de jeux sur ton espace ou ta table protozone pendant tout le festival,
                nous n'avons pas besoin d'autres renseignements.
            </Typography>

            <Divider sx={{ mt: 6, mb: 6 }} />

            <Typography variant="h5" align="center" color="red" mt={2} mb={3}>
                <b>DATE LIMITE DES INSCRIPTIONS : VENDREDI 10 AVRIL 2026</b>
            </Typography>
        </Stack >
    );

}

export default Presentation;